module.exports = __webpack_public_path__ + "assets/img/llsj3.d47a3ebf.png";